interface ButtonConfig {
  label: string;
  mathCode: string;
  charCode?: string;  // Make it optional
  useJax?: boolean;
}

interface TabConfig {
  tab: string;
  keys: ButtonConfig[];
}

export const keyMap: TabConfig[] = [

  {
      tab: "Default",
      keys: [
        { label: "summation", mathCode: "\\sum_{n=0}^{\\infty}" },
        { label: "integral", mathCode: "\\int" },
        { label: "fraction", mathCode: "\\frac{}{}" },
        { label: "square root", mathCode: "\\sqrt{ }" },
        { label: "nth root", mathCode: "\\sqrt[]{ }" },
        { label: "Square Exponent", charCode: "\\square^{2}", mathCode: "^{2}" },
        { label: "Nth Exponent", charCode: "\\square^{}", mathCode: "^{}" },
        { label: "squre subscript",charCode: "\\square_{2}", mathCode: "_{2}" },
        { label: "Nth Subscript",charCode: "\\square_{}", mathCode: "_{}" },
        { label: "parentheses", mathCode: "\\left(\\right)" },
        { label: "square brackets", mathCode: "\\left[  \\right]" },
        { label: "vertical bars", mathCode: "\\left|  \\right|" },
        { label: "curly braces", mathCode: "\\left\\{  \\right\\}" },
        { label: "plus sign", mathCode: "+" },
        { label: "forward slash", mathCode: "/" },
        { label: "multiplication sign", mathCode: "\\times" },
        { label: "plus-minus sign", mathCode: "\\pm" },
        { label: "minus sign", mathCode: "-" },
        { label: "division sign", mathCode: "\\div" },
        { label: "greater than or equal to sign", mathCode: "\\geq" },
        { label: "less than or equal to sign", mathCode: "\\leq" },
        { label: "element of sign", mathCode: "\\in" },
        { label: "subset of sign", mathCode: "\\subset" },
        { label: "union", charCode: "\\bigcup", mathCode: "\\bigcup" },
        { label: "intersection", mathCode: "\\cap" },
        { label: "empty set", mathCode: "\\emptyset" },
        { label: "infinity", mathCode: "\\infty", useJax: true },
        { label: "pi", mathCode: "\\pi", useJax: true }
    ]
  }
]